var $ = require('jquery');

module.exports = {
	init: function () {
		// FacetWP re-renders the pager on every refresh, which destroys the control
		// the user just activated and drops focus to <body>. Remember what kind of
		// control it was so focus can be put back on the equivalent one.
		var pendingFocus = null;

		$(document).on('click', '.facetwp-type-pager .facetwp-page', function () {
			var $control = $(this);

			if ($control.hasClass('next')) {
				pendingFocus = 'next';
			} else if ($control.hasClass('prev')) {
				pendingFocus = 'prev';
			} else {
				pendingFocus = 'active';
			}
		});

		// Add aria attributes to pagination links
		$(document).on('facetwp-loaded', function () {
			// Remove any existing aria-current attributes
			$('.facetwp-type-pager .facetwp-page').removeAttr('aria-current');

			// Add aria-current="page" to the active page
			$('.facetwp-type-pager .facetwp-page.active').attr('aria-current', 'page');

			// Add aria-hidden to dots
			$('.facetwp-type-pager .facetwp-page.dots').attr('aria-hidden', 'true');

			// Add descriptive aria-labels to prev/next buttons
			$('.facetwp-type-pager .facetwp-page.prev').each(function () {
				var prevPage = $(this).attr('data-page');
				if (prevPage) {
					$(this).attr('aria-label', 'Go to previous page: page ' + prevPage);
				}
			});

			$('.facetwp-type-pager .facetwp-page.next').each(function () {
				var nextPage = $(this).attr('data-page');
				if (nextPage) {
					$(this).attr('aria-label', 'Go to next page: page ' + nextPage);
				}
			});

			// Add aria-labels to numbered page links
			$('.facetwp-type-pager .facetwp-page[data-page]')
				.not('.prev, .next, .active')
				.each(function () {
					var pageNum = $(this).attr('data-page');
					$(this).attr('aria-label', 'Go to page ' + pageNum);
				});
		});

		// Bound after the handler above so the restored control already carries its
		// aria-label by the time it receives focus.
		$(document).on('facetwp-loaded', function () {
			if (!pendingFocus) {
				return;
			}

			var target = pendingFocus;
			pendingFocus = null;

			// On the first/last page the prev/next control no longer exists, so fall
			// back to the button for the page the user landed on.
			var $restore = $('.facetwp-type-pager .facetwp-page.' + target).first();

			if ($restore.length < 1) {
				$restore = $('.facetwp-type-pager .facetwp-page.active').first();
			}

			if ($restore.length > 0) {
				$restore.trigger('focus');
			}
		});
	},
};
